define.alias("shared/components/shared/ui/block", "settings/components/shared/ui/block");